module.exports = __webpack_public_path__ + "static/img/probuild.ef2dbb0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Probuild/probuild.png
// module id = XKal
// module chunks = 0